<template>
  <el-dialog
    :custom-class="$style.dialog_company_popup"
    title="添加企业认证"
    :visible="visible"
    @close="close"
  >
    <Loading :loading="loading" :text="loadingText">
      <Item title="企业名称">
        <el-input v-model="companyName"></el-input>
      </Item>
      <Item title="证件类型">
        <el-select v-model="type" value-key="id">
          <el-option
            v-for="item in typeList"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </Item>
      <Item title="证件号码">
        <el-input v-model="number"></el-input>
      </Item>
      <Item title="上传证件正面照">
        <UploadImage :imageUrl="imageUrl" @change="onFileChange" />
      </Item>
      <Item title=" ">
        <Button type="primary" size="small" @click="clickSubmit">添加</Button>
        <Button size="small" :class="$style.btn_cancel" @click="close">
          取消
        </Button>
      </Item>
    </Loading>
  </el-dialog>
</template>

<script>
import { COMPANY_TYPE_LIST } from "@constant";
import { uploadCompanyImage, createCompany } from "@server";

import UploadImage from "@components/UploadImage.vue";

export default {
  name: "CompanyPopup",
  components: {
    UploadImage,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      companyName: "", // 企业名称
      typeList: COMPANY_TYPE_LIST,
      type: "", // 证件类型
      number: "", //  证件号码

      file: null,
      imageUrl: "",
      path: "", // 图片上传后的路径(传参所需)

      loading: false,
      loadingText: "添加中...",
    };
  },
  methods: {
    async onFileChange(data) {
      this.imageUrl = data.imageUrl;
      this.file = data.file;

      // 存在文件即上传操作
      data.file && this.uploadImage(data.file);
    },

    async uploadImage(file) {
      this.loadingText = "图片上传中...";
      this.loading = true;
      const data = new FormData();
      data.append("file", file);
      const res = await uploadCompanyImage(data);

      if (res.code == 200) {
        this.$message({ message: "图片上传成功", type: "success" });
        this.path = res.data.path;
        this.companyName = res.data.companyName;
        this.number = res.data.cardNum;
        this.imageUrl = res.data.url;
      } else {
        this.$message({ message: res.message, type: "error" });
        this.file = null;
        this.imageUrl = "";
        this.path = "";
      }
      this.loading = false;
    },

    checkSubmit() {
      if (!this.companyName) {
        this.$message({ message: "请输入企业名称！", type: "warning" });
        return false;
      }
      if (!this.type) {
        this.$message({ message: "请选择证件类型！", type: "warning" });
        return false;
      }
      if (!this.number) {
        this.$message({ message: "请输入正确的证件号码！", type: "warning" });
        return false;
      }
      if (!this.path) {
        this.$message({ message: "请上传证件正面图片！", type: "warning" });
        return false;
      }

      return true;
    },

    async clickSubmit() {
      if (!this.checkSubmit()) return;

      this.loadingText = "添加中...";
      this.loading = true;

      const data = {
        companyName: this.companyName,
        cardType: this.type,
        cardNum: this.number,
        imgUrl: this.imageUrl,
        imgName: this.path,
      };
      const res = await createCompany(data);

      if (res.code == 200) {
        this.$message({ message: "添加认证成功！", type: "success" });
        this.$emit("success");
        this.close();
      } else {
        this.$message({ message: res.message, type: "error" });
      }

      this.loading = false;
    },

    close() {
      this.companyName = "";
      this.type = "";
      this.number = "";
      this.file = null;
      this.imageUrl = "";
      this.path = "";
      this.$emit("close");
    },
  },
  mounted() {},
};
</script>

<style lang="scss" module scoped>
::v-deep .dialog_company_popup {
  width: auto;

  :global {
    .el-dialog__header {
      padding: 10px rem(50);

      .el-dialog__title {
        font-size: max(rem(20), 16px);
        color: #333;
        line-height: 32px;
      }
    }

    .el-dialog__body {
      padding: rem(50);
    }

    .gl-item {
      margin-bottom: rem(40);

      .gl-item__left {
        width: rem(120);
        flex-shrink: 0;
      }

      .gl-item__right {
        min-width: rem(280);
      }
    }
  }

  .btn_cancel {
    color: $white;
    background-color: #777777;
    margin-left: rem(10);
  }
}
</style>
